import { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button, Input, Label, Table } from "reactstrap";
import AdminCompanyRow from "./AdminCompanyRow";
import AdminCompanyModal from "./AdminCompanyModal";
import { getAdminCompany } from "../../slices/admin/thunk";
import { useDispatch, useSelector } from "react-redux";

function AdminCompany(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    document.title = t('PageMain.DocumentTitle');
    const companies = useSelector(state => state.Admin.company);
    const [searchWord, setSearchWord] = useState("");
    const [isShowModal, setShowModal] = useState(false);
    const [isShowAll, setShowAll] = useState(false);
    const [modalCompany, setModalCompany] = useState(null);

    async function fetchData() {
        dispatch(getAdminCompany(isShowAll));
    }

    useEffect(() => {
        fetchData();
    }, [isShowAll])

    const handleCheckboxChange = (isChecked) => {
        setShowAll(isChecked);
    };

    return (
        <Fragment>
            <div className="d-flex flex-row align-items-start justify-content-between">
                <div className="d-flex flex-row align-items-start justify-content-start">
                    <Button size="sm" color="primary" className="mb-2 me-2" onClick={fetchData}>{t('Common.Btn.Refresh')}</Button>
                    <div className="mb-3">
                        <Input
                            name="searchWord"
                            className="form-control"
                            placeholder={t('Common.Btn.Search')}
                            type="text"
                            value={searchWord}
                            onChange={(event)=> {
                                setSearchWord(event.target.value);
                            }}
                        />
                    </div>
                    <div className="form-check ms-3 mt-1" >
                        <Input className="form-check-input" type="checkbox" checked={isShowAll} id="is-company-enabled-check"  onChange={(e) => handleCheckboxChange(e.target.checked)}/>
                        <Label className="form-check-label" htmlFor="is-company-enabled-check">{t('PageAdmin.Btn.DisplayDisabledCompany')}</Label>
                    </div>
                </div>
                <Button size="sm" color="secondary" className="mb-2 me-2" onClick={()=> {setModalCompany(null); setShowModal(true);}}>{t('PageAdmin.Btn.CreateCompany')}</Button>
            </div>
            
            
            <div className="device-table" style={{ maxHeight: '100%', overflowY: 'auto' }}>
                <Table className="table-nowrap mb-3">
                    <thead className="table-light sticky-header">
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">{t('PageAdmin.CompanyTable.ID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.Name')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.SystemType')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.WebsiteVersion')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.Status')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.CreatedAt')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.LastUpdatedAt')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.Action')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {companies.map((d) => {
                            if ((searchWord !== "" 
                                && d.name.indexOf(searchWord) === -1 
                                && d.contact.indexOf(searchWord) === -1 
                                && d.system_type.indexOf(searchWord) === -1 
                                && d.website_version.indexOf(searchWord) === -1 
                                && d.created_at.indexOf(searchWord) === -1
                                && d.user_manual.indexOf(searchWord) === -1
                                && d.contact.indexOf(searchWord) === -1
                                && d.remark.indexOf(searchWord) === -1
                            ))
                            {
                                return null;
                            }
                            return (
                                <AdminCompanyRow data={d} key={d.id} onClickModify={()=>{setModalCompany(d); setShowModal(true);}} onSelectedSimCompany={(selectedCompany)=> {
                                props.onSelectedSimCompany(selectedCompany)}} onSelectedDeviceCompany={props.onSelectedDeviceCompany}/>
                            );
                        })}
                    </tbody>
                </Table>
                <AdminCompanyModal show={isShowModal} onCloseClick={()=>{setShowModal(false)}} data={modalCompany}/>
            </div>
        </Fragment>
    );
}

export default AdminCompany;